module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('section', {
    staticClass: "container grid-960"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "navbar-section"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-action ml-10",
    attrs: {
      "title": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "icon icon-refresh"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content container grid-960"
  }, [(_vm.csv.errors && _vm.csv.errors.length > 0) ? _c('div', {
    staticClass: "toast toast-error"
  }, _vm._l((_vm.csv.errors), function(e) {
    return _c('p', [_c('strong', [_vm._v(_vm._s(e.type) + " (row: " + _vm._s(e.row) + "):")]), _vm._v(" " + _vm._s(e.message) + ".\n      ")])
  })) : _vm._e(), _vm._v(" "), (_vm.incomingFiles.length > 0 && !_vm.csv.meta) ? _c('div', {
    staticClass: "toast"
  }, [_vm._v("\n      Downloaded incoming files for you: " + _vm._s(_vm.incomingFiles.join(', ')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.csv.meta),
      expression: "!csv.meta"
    }],
    staticClass: "empty file-drop-area",
    class: {
      'is-active': _vm.csvDropActive
    }
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("No CSV file uploaded")]), _vm._v(" "), _c('p', {
    staticClass: "empty-subtitle"
  }, [_vm._v("Drag and drop a CSV file here, or click the button.")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Choose file")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "accept": ".csv, text/csv"
    },
    on: {
      "change": _vm.parse,
      "dragleave": function($event) {
        _vm.csvDropActive = false
      },
      "blur": function($event) {
        _vm.csvDropActive = false
      },
      "drop": function($event) {
        _vm.csvDropActive = false
      },
      "dragenter": function($event) {
        _vm.csvDropActive = true
      },
      "focus": function($event) {
        _vm.csvDropActive = true
      },
      "click": function($event) {
        _vm.csvDropActive = true
      }
    }
  })])]), _vm._v(" "), (_vm.csv.meta) ? _c('div', [_c('ul', {
    staticClass: "tab tab-block"
  }, [_c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    staticClass: "badge",
    class: {
      active: _vm.activeTab === 'G'
    },
    attrs: {
      "href": "#",
      "data-badge": _vm.filteredGroups.length
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'G'
      }
    }
  }, [_vm._v("Groups")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    staticClass: "badge",
    class: {
      active: _vm.activeTab === 'F'
    },
    attrs: {
      "href": "#",
      "data-badge": _vm.files.length
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'F'
      }
    }
  }, [_vm._v("Feedback Files")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    staticClass: "badge",
    class: {
      active: _vm.activeTab === 'S'
    },
    attrs: {
      "href": "#",
      "data-badge": _vm.filteredStudents.length
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'S'
      }
    }
  }, [_vm._v("Participants")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item tab-action ml-10"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  }, [_c('button', {
    staticClass: "btn btn-primary input-group-btn ml-10 mr-10",
    on: {
      "click": _vm.unparse
    }
  }, [_vm._v("Download CSV")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary input-group-btn ",
    on: {
      "click": _vm.zip
    }
  }, [_vm._v("Download ZIP")])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'G'),
      expression: "activeTab === 'G'"
    }]
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.langLookup.group))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.langLookup.grade))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.langLookup.feedback))]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("File")])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.filteredGroups), function(group, $index) {
    return _c('tr', {
      key: group
    }, [_c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.filterGroup(group)
        }
      }
    }, [_vm._v(_vm._s(group))])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.groups[group][_vm.langLookup.grade]),
        expression: "groups[group][langLookup.grade]"
      }],
      staticClass: "grade",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.groups[group][_vm.langLookup.grade])
      },
      on: {
        "change": function($event) {
          _vm.updateGroupField($event, group, _vm.langLookup.grade)
        },
        "keyup": function($event) {
          _vm.updateGroupField($event, group, _vm.langLookup.grade)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.groups[group], _vm.langLookup.grade, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.groups[group][_vm.langLookup.feedback]),
        expression: "groups[group][langLookup.feedback]"
      }],
      staticClass: "feedback",
      domProps: {
        "value": (_vm.groups[group][_vm.langLookup.feedback])
      },
      on: {
        "keyup": function($event) {
          _vm.updateGroupField($event, group, _vm.langLookup.feedback)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.groups[group], _vm.langLookup.feedback, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.groupFillDownFrom($index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-downward"
    }), _vm._v(" Fill down")])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.filenameForGroup(group)) + "\n              ")])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "import"
    }
  }, [_vm._v("Import values group, grade, comment (no header, copy past from Excel\n            or CSV)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupsImportData),
      expression: "groupsImportData"
    }],
    staticClass: "form-input",
    attrs: {
      "id": "import",
      "placeholder": "A01, 1, ",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.groupsImportData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupsImportData = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.importGroupFeedback
    }
  }, [_vm._v("Import")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'F'),
      expression: "activeTab === 'F'"
    }]
  }, [_c('div', {
    staticClass: "empty file-drop-area",
    class: {
      'is-active': _vm.csvDropActive
    }
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("Drag and drop feedback files or a zip with files")]), _vm._v(" "), _c('p', {
    staticClass: "empty-subtitle"
  }, [_vm._v("The feedback file should include the name of a group to be matched.")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Choose file")]), _vm._v(" "), _c('input', {
    ref: "feedbackInput",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFeedbackFiles,
      "dragleave": function($event) {
        _vm.csvDropActive = false
      },
      "blur": function($event) {
        _vm.csvDropActive = false
      },
      "drop": function($event) {
        _vm.csvDropActive = false
      },
      "dragenter": function($event) {
        _vm.csvDropActive = true
      },
      "focus": function($event) {
        _vm.csvDropActive = true
      },
      "click": function($event) {
        _vm.csvDropActive = true
      }
    }
  })])]), _vm._v(" "), _c('ul', _vm._l((_vm.files), function(file) {
    return _c('li', [_vm._v(_vm._s(file.name))])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'S'),
      expression: "activeTab === 'S'"
    }],
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.csv.meta) ? _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.csv.meta.fields), function(field) {
    return _c('th', [_vm._v(_vm._s(field))])
  }))]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.filteredStudents), function(student) {
    return _c('tr', {
      key: student[_vm.langLookup.identifier]
    }, _vm._l((_vm.csv.meta.fields), function(field) {
      return _c('td', [(_vm.isEditableNumber(field)) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (student[field]),
          expression: "student[field]"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": student[_vm.langLookup.gradeMax]
        },
        domProps: {
          "value": (student[field])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(student, field, $event.target.value)
          }
        }
      }) : (_vm.isEditableTextarea(field)) ? _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (student[field]),
          expression: "student[field]"
        }],
        domProps: {
          "value": (student[field])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(student, field, $event.target.value)
          }
        }
      }) : (field === _vm.langLookup.group) ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.filterGroup(student[field])
          }
        }
      }, [_vm._v(_vm._s(student[field]))]) : _c('span', [_vm._v(_vm._s(student[field]))])])
    }))
  }))], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "navbar-section"
  }, [_c('a', {
    staticClass: "navbar-brand mr-10",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Moodle Assignment Feedback Packager")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "https://github.com/bfritscher/moodle-assignment-feedback-packager"
    }
  }, [_vm._v("GitHub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "icon icon-upload"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "icon icon-upload"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Processing file(s)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "loading"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-353bff4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 213
// module chunks = 1